import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { environment } from '@environments/environment';
import { Coach } from '../../models';

@Component({
  selector: 'app-lineup-coachs-group',
  standalone: true,
  imports: [],
  templateUrl: './lineup-coachs-group.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LineupCoachsGroupComponent {
  title = input.required<string>();
  homeCoach = input.required<Coach | null>();
  awayCoach = input.required<Coach | null>();

  getAwayImageUrl() {
    if (!this.awayCoach()?.Photo || this.awayCoach()?.Photo.length === 0) {
      return environment.urlIMG + 'default.png';
    }
    return this.awayCoach()?.Photo;
  }
  getHomeImageUrl() {
    if (!this.homeCoach()?.Photo || this.homeCoach()?.Photo.length === 0) {
      return environment.urlIMG + 'default.png';
    }
    return this.homeCoach()?.Photo;
  }
}
